import { prefixPhoneNumber } from '~src/utils/prefixPhoneNumber';

export const createWhatsappUrl = (s) => {
  const prefixedPhoneNumber = prefixPhoneNumber(s);

  return `https://wa.me/${prefixedPhoneNumber}`;
};
